<template>
    <div v-if="this.entries">
        <div class="">
            <h5><b>{{ $t('message.SettingPage.webhook.title') }}</b></h5>
        </div>
        <ul class="list-group">
            <template v-for="(entry, index) in this.entries" :key="index">
                <li class="list-group-item">
                    <div class="row d-flex align-items-center justify-content-between">
                        <div class="d-flex col-10 align-items-center">  
                            <i :class="[(entry.icon),(isExistInArrayChecked(entry, this.options) == true ? 'icon-active' : '')]" class="mr-3" style="font-size: 20px;"></i>
                            <div>
                                <h6 class="m-0"><b>{{ entry.name }}</b></h6>
                                <div class="setting-sync-des text-gray">{{ entry.desc }}</div>
                            </div>
                        </div>
                        <div class="col-2 d-flex justify-content-end">
                            <span class="toggle" :class="isExistInArrayChecked(entry, this.options) == true ? 'active' : ''"
                                @click="changeOption(entry)"></span>
                        </div>
                    </div>
                </li>
            </template>
        </ul>
    </div>
</template>

<script>
import { $post, $get } from "@/lib/utils";
import toastr from 'toastr';
export default {
    name: "SettingSync",
    props: ['entries'],
    data() {
        return {
            options: []
        }
    },
    methods: {
        async changeOption(entry) {
            let status = false;
            let arr = this.options;
            if (arr.includes(entry.id)) {
                arr = arr.filter(item => item !== entry.id)
            } else {
                arr.push(entry.id);
                status = true;
            }
            this.options = arr;

            const result = await $post('/v1/setting-store/update-option', {id: entry.id, status: status, register: entry.typeRegister});
            if (result.result == true) {
                toastr.success(this.$t('message.SettingPage.success'));
            }
        },
        isExistInArrayChecked(entry, array = []) {
            if (array.includes(entry.id)) {
                return true;
            } else {
                return false;
            }
        },
    },
    watch: {
        entries: {
            handler: function (newValue) {
                this.options = [];
                newValue.forEach((item) => {
                    if (item && item.status) {
                        this.options.push(item.id);
                    }
                });
            },
            deep: true
        },
    }
}
</script>

<style scoped>
.setting-sync-content .setting-sync-item {
    overflow: unset;
}

.setting-sync-content {
    max-height: calc(100vh - 200px);
    overflow-y: auto;
}

.setting-sync-item {
    background-color: #f1f1f1;
    overflow: hidden;
    margin-top: 1rem;
    padding: 1rem 2rem;
    border-radius: 10px;
}

.toggle {
    background-color: rgba(31, 32, 33, .15);
    position: relative;
    display: block;
    cursor: pointer;
    border-radius: 14px;
    width: 51px;
    height: 28px;
    transition: all .2s ease-in-out;
}

.toggle.active {
    background-color: rgb(47, 161, 161);
}

.toggle:before {
    content: "";
    background-color: #fff;
    border-radius: 999px;
    width: 24px;
    height: 24px;
    position: absolute;
    left: 2px;
    top: 2px;
    transition: all .2s ease-in-out;
}

.toggle.active:before {
    left: auto;
    right: 2px;
    transition: all .2s ease-in-out;
}
.icon-active {
    color: rgb(47, 161, 161);
}
</style>